import { render, staticRenderFns } from "./EmployeeGrantForm.vue?vue&type=template&id=a79d650e&scoped=true&"
import script from "./EmployeeGrantForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeGrantForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79d650e",
  null
  
)

export default component.exports